import type { FaireProductEntity } from "../../entity_types/product";

export const p_846vtnqbjf: FaireProductEntity = {
  token: "p_846vtnqbjf",
  type: "product",
  name: "JAMI - Print Knee High Boot",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/d63b31ed1fea6b1052f278413039d7267112833092efdb42164681387be5670c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d65e400e7afdad78c37c7be738e682230bf348715a686bb495d6cde88426efd5.jpeg",
    "https://cdn.faire.com/fastly/4d45137994c66ce2307ce36316fdff7d9a84d15e4048dca586e34b924ea2521e.jpeg",
    "https://cdn.faire.com/fastly/7cb42c525fd0ff5bf211130974db49ebdf32f55363efe2d3042faee3b226253b.jpeg",
    "https://cdn.faire.com/fastly/77d5eac2d192a9cbceceeee371092387ce184df0282ebc3c5be517117e5b4fa5.jpeg",
    "https://cdn.faire.com/fastly/090b61a56e3f0998264b4beec9a7af636e7164ee405d28659973241ae04e58d2.jpeg",
  ],
  priceDollars: 23.25,
  description:
    "Turn heads in these statement-making knee-high boots featuring standout prints and textures that add personality to every outfit. Designed with a comfortable block heel, rounded toe, and easy pull-on silhouette, this fashion-forward style blends playful charm with everyday wearability. Whether you gravitate toward gingham, florals, animal-inspired prints, these boots are made to elevate any look.\n\nOOTD\nStyle them with a chunky knit sweater dress and tights for an effortless fall outfit, or pair them with denim shorts and a fitted turtleneck for a trend-driven look. For a more feminine vibe, wear them with a flowy midi dress and layered jewelry. Let the print do the talking by keeping the rest of your outfit simple and neutral.",
  tags: [],
  msrpDollars: 46.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:49:19.382Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
